define('shoppingCartIcon/shoppingCartIcon',[
],
    function () {

        const itemCountSelector = ".shopping-cart-icon .item-count";

        function updateItemCount(count) {
            $(itemCountSelector).empty();
            if (count > 0) {
                $(itemCountSelector).text(count);
            }
        }

        return {
            updateItemCount: updateItemCount
        };
    });

